module.exports = __webpack_public_path__ + "img/25.a6222c4f.png";